module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/babel-runtime/core-js/json/stringify.js
// module id = nnK5
// module chunks = 0